import { render, staticRenderFns } from "./DocList.vue?vue&type=template&id=f089c696"
import script from "./DocList.vue?vue&type=script&lang=js"
export * from "./DocList.vue?vue&type=script&lang=js"
import style0 from "./DocList.vue?vue&type=style&index=0&id=f089c696&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports